module.exports = __webpack_public_path__ + "static/media/earnings_icon.f09338c8.svg";